import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import css from './EventsDisplay.css';

const DISABLED = [
    { label: 'Session', value: 'session', disabled: true },
    { label: 'Revenue', value: 'revenue', disabled: true },
];

const EventsDisplay = ({ events = [] }) => {
    const [expanded, setExpanded] = useState(false);
    const containerRef = useRef(null);

    const allEvents = [...DISABLED, ...events];
    const visibleItems = expanded ? allEvents : allEvents.slice(0, 5);
    const hiddenCount = allEvents.length - 5 > 0 ? allEvents.length - 5 : 0;

    const toggleExpand = () => {
        setExpanded(!expanded);
    };

    useEffect(() => {
        const handleOutsideClick = event => {
            if (containerRef.current && !containerRef.current.contains(event.target) && expanded) {
                setExpanded(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [expanded]);

    const renderTabs = tabItems => {
        return tabItems.map(item => (
            <div key={item.value} className={`${css.tab} ${item.disabled ? css.disabled : ''}`}>
                {item.label}
            </div>
        ));
    };

    return (
        <div className={css.eventsContainer} ref={containerRef}>
            <div className={css.tabsContainer}>
                {renderTabs(expanded ? allEvents : visibleItems)}
                {!expanded && hiddenCount > 0 && (
                    <div className={css.expandButton} onClick={toggleExpand}>
                        + {hiddenCount}
                    </div>
                )}
            </div>
        </div>
    );
};

EventsDisplay.propTypes = {
    events: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.string,
        })
    ),
};

export default EventsDisplay;
